var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProviderStaffOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.483 23.897c-.986.908-1.725 2.167-1.911 3.587l-.003.02-.764 3.996h24.39l-.764-3.997a.968.968 0 01-.005-.037c-.161-1.407-.893-2.66-1.884-3.567-1.005-.92-2.18-1.399-3.13-1.399a1.125 1.125 0 010-2.25c1.639 0 3.333.786 4.649 1.99 1.324 1.212 2.362 2.934 2.598 4.95l.954 5.27a1.125 1.125 0 01-1.113 1.29h-27a1.125 1.125 0 01-1.113-1.29l.955-5.279c.266-2.007 1.298-3.725 2.617-4.94 1.307-1.203 2.988-1.991 4.629-1.991a1.125 1.125 0 010 2.25c-.947 0-2.107.478-3.105 1.397z",
    fill: "#6D6D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.088 21.825a1.125 1.125 0 10-1.8 1.35l1.391 1.855-1.617 8.72h2.25l1.516-7.875h.344l1.515 7.875h2.25l-1.616-8.72 1.392-1.855a1.125 1.125 0 00-1.8-1.35l-1.35 1.8h-1.125l-1.35-1.8z",
    fill: "#6D6D6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 4.5a2.25 2.25 0 012.25-2.25h9a2.25 2.25 0 012.25 2.25v3.375c0 .122-.02.24-.056.35a7.875 7.875 0 11-13.389 0 1.122 1.122 0 01-.055-.35V4.5zm2.25 0h9v2.25h-9V4.5zm0 4.5a5.625 5.625 0 109 0h-9z",
    fill: "#6D6D6D"
  })));
}

export default SvgProviderStaffOutline;